export default "__VITE_ASSET__Crs7OPGC__"